module.exports = __webpack_public_path__ + "c45f7de008ab976a8e817e3c0e5095ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Pe-icon-7-stroke.svg?d7yf1v
// module id = 73
// module chunks = 0